
define('contestacao-vistoria-controller',[
    'contestacao-vistoria-resource',
    'directive/ng-flow/dist/ng-flow-standalone.min',
    'directive/flow.js/dist/flow.min',
    'directive/ng-flow/dist/ng-flow.min',
    'angular-file-upload',
], function () {

    var app = angular.module('contestacao.vistoria.controller', [
        'contestacao.vistoria.resource',
        'ui.mask',
        'flow',

    ]);

    app.controller('ContestacaoVistoriaControllerIndex', ['$scope', '$rootScope', 'ContestacaoVistoria', '$mdDialog', function ($scope, $rootScope, ContestacaoVistoria, $mdDialog) {

        $scope.contestacoes = contestacoes;


        $scope.notificarImobiliaria = function (vis_codigo) {
            if (confirm('Um e-mail será enviado para a imobiliária, informando que você concluiu a contestação')) {
                ContestacaoVistoria.notifImobContest(vis_codigo).then(res => {
                    if (res.msg) {
                        alert(res.msg);
                        return;
                    }
                    alert('Email enviado! Sua contestação foi enviada para imobiliária com sucesso.');
                });

            }

        }
    }]);

    app.controller('ContestacaoVistoriaControllerAdd', ['$scope', '$rootScope', 'ContestacaoVistoria', '$mdDialog', '$location','$window',
    function ($scope, $rootScope, ContestacaoVistoria, $mdDialog, $location,$window) {
        $scope.pagina = 'Contestar';

        $scope.showContestacao = false;

        $scope.medidores = medidores;
        $scope.chaves = chaves;
        $scope.ambientes = ambientes;
        $scope.vistoria = vistoria;

        $scope.contestar = function (item, nome) {
            if (item[nome]) {
                $scope.contestacao = item[nome];
            } else {
                $scope.contestacao = item;
            }

            if($scope.contestacao.status=='Aprovado')return;

            $scope.showError = false;
            $scope.contestacao.vis_codigo = $scope.vistoria.vis_codigo;
            $scope.showContestacao = true;
            $scope.salvarContestacao = function (form, $flow) {
                if (form.$valid) {
                    let json = {};
                    json[nome] = $scope.contestacao;

                    if ($flow.files.length > 0) {
                        $scope.submitFlow($flow, nome);
                        return;
                    }

                    ContestacaoVistoria.saveContestacao(vistoria.vis_codigo, json).then(function (obj) {
                        $scope.showContestacao = false;
                        item[nome] = obj;
                        if (obj.obj) item[nome] = obj.obj;

                    });
                } else {
                    angular.forEach(form.$error.required, function (value, key) {
                        form.$error.required[key].$pristine = false;
                    });
                }
            }
        }


        $scope.excluir = function (item, nome) {
            $scope.contestacao = item[nome];
            $scope.contestacao.vis_codigo = $scope.vistoria.vis_codigo;
            let json = {};
            json[nome] = $scope.contestacao;
            ContestacaoVistoria.deleteContestacao(vistoria.vis_codigo, json).then(function (obj) {
                if (obj.success) {
                    delete item[nome];
                }
                alert(obj.msg);
            });
        }

        // 
        $scope.fileAdded = function (file) {
            file.flowObj.files = [];

            if (!file.file.type.startsWith('image/')) {
                $scope.msgError = 'Apenas imagens são permitidas (JPEG, PNG, etc.).'
                $scope.showError = true;
                return;
            }

            // if (file.size>(20*1024*1024)) {
            //     $scope.msgError = 'Tamanho máximo excedido.'
            //     $scope.showError = true;
            //     return;
            // }
            $scope.showError = false;
        };


        $scope.submitFlow = function ($flow, nome) {
            let query = $scope.contestacao;
            query.modelname = nome;
            $flow.files =$flow.files.filter(function (file) {
                return file.file.type.startsWith('image/');
              });

            $scope.totalFiles = $flow.files.length; // limitando upload de arquivos
            if ($scope.totalFiles > 1) $scope.totalFiles == 1;
            $flow.opts.target = `/areacliente/saveContestacao/${vistoria.vis_codigo}`;
            // $flow.opts.chunkSize = 1024*1024; //pra testar local
            $flow.opts.forceChunkSize = true;
            $flow.opts.query = $scope.contestacao;
            $flow.upload();

        };



        $scope.uploadComplete = function ($flow) {
            $flow.files.length = 0;
            alert('Contestação salva!');
            ContestacaoVistoria.reloadContestacao(vistoria.vis_codigo, true).then(result => {
                $scope.medidores = result.medidores;
                $scope.chaves = result.chaves;
                $scope.ambientes = result.ambientes;
                $scope.vistoria = result.vistoria;
            });
            $scope.showContestacao = false;


        }

        $scope.closemodal = function () {
            $scope.showContestacao = false;

        }

        $scope.imgext = {
            '16': {
                'png': '/site/public/theme/assets/img/16px/png.png',
                'jpg': '/site/public/theme/assets/img/16px/jpg.png',
                'jpeg': '/site/public/theme/assets/img/16px/jpg.png',
                'doc': '/site/public/theme/assets/img/16px/doc.png',
                'docx': '/site/public/theme/assets/img/16px/doc.png',
                'zip': '/site/public/theme/assets/img/16px/zip.png',
                'rar': '/site/public/theme/assets/img/16px/rar.png',
                'bmp': '/site/public/theme/assets/img/16px/bmp.png',
                'js': '/site/public/theme/assets/img/16px/js.png',
                'mp3': '/site/public/theme/assets/img/16px/mp3.png',
                '_blank': '/site/public/theme/assets/img/16px/_blank.png',
                'css': '/site/public/theme/assets/img/16px/css.png',
                'pdf': '/site/public/theme/assets/img/16px/pdf.png',
                'gif': '/site/public/theme/assets/img/16px/gif.png',
                'ppt': '/site/public/theme/assets/img/16px/ppt.png'
            },
            '32': {
                'png': '/site/public/theme/assets/img/32px/png.png',
                'jpg': '/site/public/theme/assets/img/32px/jpg.png',
                'jpeg': '/site/public/theme/assets/img/32px/jpg.png',
                'doc': '/site/public/theme/assets/img/32px/doc.png',
                'docx': '/site/public/theme/assets/img/32px/doc.png',
                'zip': '/site/public/theme/assets/img/32px/zip.png',
                'rar': '/site/public/theme/assets/img/32px/rar.png',
                'bmp': '/site/public/theme/assets/img/32px/bmp.png',
                'js': '/site/public/theme/assets/img/32px/js.png',
                'mp3': '/site/public/theme/assets/img/32px/mp3.png',
                '_blank': '/site/public/theme/assets/img/32px/_blank.png',
                'css': '/site/public/theme/assets/img/32px/css.png',
                'pdf': '/site/public/theme/assets/img/32px/pdf.png',
                'gif': '/site/public/theme/assets/img/32px/gif.png',
                'ppt': '/site/public/theme/assets/img/32px/ppt.png'
            }
        };

        $scope.getIcoExt = function (file, tm) {
            if (file) {
                var ext = file.split('.').pop();
                if (typeof $scope.imgext[tm][ext] != 'undefined') {
                    return $scope.imgext[tm][ext];
                } else {
                    return $scope.imgext[tm]['_blank'];
                }
            }
        };

        $scope.notificarImobiliaria = function () {
            if (confirm('Um e-mail será enviado para a imobiliária, informando que você concluiu a contestação')) {
                ContestacaoVistoria.notifImobContest(vistoria.vis_codigo).then(res => {
                    $window.history.back();
                    if (res.msg) {
                        alert(res.msg);
                        return;
                    }
                    alert('Email enviado! Sua contestação foi enviada para imobiliária com sucesso');
                });

            }

        }

    }]);
});

